import { formatPhoneNumber } from '../../helper';

export default function ViewUserDetails(props) {
  return <>
    <h3>User Info</h3>
    <div className="text-blk">
      <span className="label">
        First Name:
      </span>
      <span className="value">
        {props.data.first_name ? props.data.first_name : 'N/A'}
      </span>
    </div>
    <div className="text-blk">
      <span className="label">
        Last Name:
      </span>
      <span className="value">
        {props.data.last_name ? props.data.last_name : 'N/A'}
      </span>
    </div>
    <div className="text-blk">
      <span className="label">
        Gender:
      </span>
      <span className="value">
        {props.data.gender ? props.data.gender : 'N/A'}
      </span>
    </div>
    <div className="text-blk">
      <span className="label">
        Email:
      </span>
      <span className="value">
        {props.data.email ? props.data.email : 'N/A'}
      </span>
    </div>
    <div className="text-blk">
      <span className="label">
        Primary Phone:
      </span>
      <span className="value">
        {props.data.cell_phone ? formatPhoneNumber(props.data.cell_phone) : 'N/A'}
      </span>
    </div>
    <div className="text-blk">
      <span className="label">
        Secondary Phone:
      </span>
      <span className="value">
        {props.data.secondary_phone ? formatPhoneNumber(props.data.secondary_phone) : 'N/A'}
      </span>
    </div>
    <div className="text-blk">
      <span className="label">
        Shirt Size:
      </span>
      <span className="value">
        {props.shirtSize}
      </span>
    </div>
    <div className="text-blk">
      <span className="label">
        Registered through:
      </span>
      <span className="value">
        {props.data.registered_through ? (props.data.registered_through === 'C' ? 'Cleveland Plays' : 'Mulberry') : 'N/A'}
      </span>
    </div>
    <div className="text-blk">
      <span style={{
        cursor: 'pointer',
      }} className="reset-link" onClick={() => props.openResetPasswordPopUp(true)}>Reset Password</span>
    </div>
    <div className="text-blk">
      <div className="checkbox-container">
        <label className="checkbox">
          Disable Account
          <input type="checkbox"
            value={props.checkbox}
            checked={props.checkbox}
            name="account_locked"
            onChange={() => { props.changeAccountStatus() }}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    </div>

    {
      props?.leagueInfo && Array.isArray(props?.leagueInfo) && props?.leagueInfo.length > 0 &&
      <>
        <h3>Leagues</h3>
        <ul>
          {
            props?.leagueInfo.map((val, key) => {
              if(val?.team?.name) {
                return <li key={key}><div>{`${val?.team?.league?.name}`}</div>
                  <div><strong>Team:</strong> {val?.team?.name}</div>
                </li>
              } else {
                return null;
              }
            })
          }

        </ul>
      </>
    }

  </>
}